const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  name: yup.string().required("Name is required"),
});

module.exports = {
  create,
};
